<h2 mat-dialog-title style="padding: 10px">Terminos y condiciones</h2>
<div>
  <mat-dialog-content class="mat-typography" style="padding: 0 50px;">
    <p>
      POLÍTICA DE PRIVACIDAD, TRATAMIENTO Y PROTECCIÓN DE DATOS PERSONALES
    </p>
    <p>
      Con la autorización del tratamiento de datos personales el titular de los
      mismos acepta los términos de la presente política. <strong>Asegúrate Limitada</strong> es respetuosa de los datos
      personales e
      información que le suministran sus clientes actuales, pasados y
      potenciales. En la presente Política de Privacidad, se establecen las
      finalidades, medidas y procedimientos de nuestras bases de datos, así como
      los mecanismos con que cuentan los titulares para conocer, actualizar,
      rectificar, suprimir los datos suministrados o revocar la autorización.
    </p>
    <p>
      1. RESPONSABLE Y ENCARGADO DEL TRATAMIENTO DE DATOS.
    </p>
    <p>
      El responsable del tratamiento de datos personales es la Coordinación de
      Mercadeo. Los siguientes son sus datos de contacto:
    </p>
    <p>
      a. Domicilio: Bogotá D.C.
    </p>
    <p>
      b. Dirección: Calle 71A # 17 – 35 Of. 303
    </p>
    <p>
      c. Número de teléfono: (+57 1) 255 9532
    </p>
    <p>
      2. FINALIDAD DE LA BASE DE DATOS.
    </p>
    <p>
      La base de datos tiene como finalidades principales informarle sobre los
      servicios que prestamos, para fines administrativos, comerciales y de
      publicidad y contacto frente a los titulares de los mismos.
    </p>
    <p>
      3. DATOS PERSONALES.
    </p>
    <p>
      La información objeto de tratamiento por parte de <strong>Asegúrate Limitada</strong>, en adelante en este
      documento “Datos
      personales”, es aquella que suministran los Titulares, cuando acceden a sus
      bienes y/o servicios, o con ocasión de los mismos, tales como: nombre,
      apellidos, identificación, edad, sexo, teléfono, dirección física y
      electrónica, país, ciudad y demás datos necesarios que le sean solicitados
      en el proceso de registro, los cuales en ningún caso serán de carácter
      sensible en los términos de ley. <strong>Asegúrate Limitada</strong> no
      recopilará datos considerados como Datos Sensibles según lo dispuesto en la
      Ley 1581 de 2012, como por ejemplo, datos que revelen el origen racial o
      étnico, la orientación política, las convicciones religiosas o filosóficas,
      pertenencia a sindicatos, organizaciones sociales, datos relacionados con
      la salud, vida sexual o datos biométricos.
    </p>
    <p>
      4. AUTORIZACIÓN PARA RECOLECCIÓN Y TRATAMIENTO DE DATOS PERSONALES Y OTRA
      INFORMACIÓN.
    </p>
    <p>
      Mediante la autorización expresa verbal o por escrito, el Titular autoriza
      expresa o inequívocamente a <strong>Asegúrate Limitada</strong> S.A.S para
      recolectar datos personales y cualquier otra información que suministre,
      así como para realizar el tratamiento sobre sus datos personales, de
      conformidad con esta Política de Privacidad y la ley. 5. TRATAMIENTO DE LOS
      DATOS PERSONALES ALMACENADOS EN LAS BASES DE DATOS DE <strong>Asegúrate Limitada</strong>
    </p>
    <p>
      <strong>Asegúrate Limitada</strong>
      solo usará, procesará y circulará los datos personales para las finalidades
      descritas y para los tratamientos autorizados en esta Política de
      Privacidad o en las leyes vigentes. En adición a lo mencionado en otras
      cláusulas, cada TITULAR expresamente autoriza a <strong>Asegúrate Limitada</strong>. para la recolección, uso y
      circulación
      de sus datos personales y otra información para los siguientes propósitos:
    </p>
    <p>
      I. Establecer comunicación entre <strong>Asegúrate Limitada</strong>. y el
      TITULAR para cualquier propósito relacionado con las finalidades que se
      establecen en la presente política, ya sea mediante llamadas, mensajes de
      texto, correos electrónicos y/o físicos.
    </p>
    <p>
      II. Auditar, estudiar, analizar y utilizar la información de la Base de
      Datos para diseñar, implementar y desarrollar programas, proyectos y
      eventos.
    </p>
    <p>
      III. Auditar, estudiar, analizar y utilizar la información de la Base de
      Datos para la socialización de políticas, proyectos, programas, resultados
      y cambios organizacionales.
    </p>
    <p>
      IV. Ofrecer productos y/o servicios
    </p>
    <p>
      V. Evaluar los hábitos de consumo de los titulares, hacer análisis y/o
      segmentación de mercado y/o estadísticos.
    </p>
    <p>
      VI. Solicitar la opinión de el Titular sobre productos y/o servicios
    </p>
    <p>
      VII. Cuando la información deba ser revelada para cumplir con leyes,
      regulaciones o procesos legales, para asegurar el cumplimiento de los
      términos y condiciones, para detener o prevenir fraudes, ataques a la
      seguridad de <strong>Asegúrate Limitada</strong>. o de otros, prevenir
      problemas técnicos o protegerlos derechos de otros como lo requieran los
      términos y condiciones o la ley.
    </p>
    <p>
      VIII. Los demás descritos en la presente política o en la Ley.
    </p>
    <p>
      6. ALMACENAMIENTO DE DATOS PERSONALES.
    </p>
    <p>
      El Titular autoriza expresamente a <strong>Asegúrate Limitada</strong>.
      para que este lo almacene de la forma que considere más oportuna y cumpla
      con la seguridad requerida para la protección de los datos.
    </p>
    <p>
      7. MEDIDAS DE SEGURIDAD <strong>Asegúrate Limitada</strong>.
    </p>
    <p>
      se compromete al uso correcto y tratamiento de los datos personales,
      evitando el acceso no autorizado de terceros que permita conocer o
      vulnerar, modificar, divulgar y/o destruir la información que reposa en sus
      bases de datos. Por tal motivo, <strong>Asegúrate Limitada</strong> cuenta
      con protocolos de seguridad y acceso a sus sistemas de información,
      almacenamiento y procesamiento incluidas medidas físicas de control de
      riesgos de seguridad.
    </p>
    <p>
      8 DERECHOS DE LOS TITULARES.
    </p>
    <p>
      <strong>Asegúrate Limitada</strong>
      . informa a los titulares que, conforme a la legislación vigente, estos
      tienen el derecho de conocer, actualizar, rectificar su información, y/o
      revocar la autorización para su tratamiento. En particular, son derechos de
      los titulares según se establece en el artículo 8 de la Ley 1581 de 2012:
    </p>
    <p>
      a. Conocer, actualizar y rectificar sus datos personales,
    </p>
    <p>
      b. Solicitar prueba de la autorización otorgada,
    </p>
    <p>
      c. Ser informado, previa solicitud, respecto del uso que le ha dado a sus
      datos personales,
    </p>
    <p>
      d. Presentar ante la Superintendencia de Industria y Comercio quejas por
      infracciones a lo dispuesto en la ley,
    </p>
    <p>
      e. Revocar la autorización y/o solicitar la supresión del dato,
    </p>
    <p>
      f. Acceder en forma gratuita a sus datos personales que hayan sido objeto
      de Tratamiento.
    </p>
    <p>
      a. Persona encargada de peticiones, consultas y reclamos. La persona
      encargada de atender las peticiones, consultas y reclamos de los titulares
      para ejercer sus derechos a conocer, actualizar, rectificar y suprimir sus
      datos y revocar su autorización es la Coordinación de Mercadeo.
    </p>
    <p>
      b. Procedimiento para ejercer sus derechos. En caso de que desee ejercer
      sus derechos, el titular deberá enviar un correo electrónico o físico a las
      direcciones de contacto establecidas en la presente Política de Privacidad.
    </p>
    <p>
      c. Peticiones y Consultas Sobre Datos Personales. Cuando el titular de los
      datos o sus causahabientes deseen consultar la información que reposa en la
      base de datos, <strong>Asegúrate Limitada</strong>. responderá la solicitud
      en plazo de máximo diez (10) días. En cumplimiento a lo dispuesto en la Ley
      1581 de 2012, cuando no fuere posible atender la consulta dentro de dicho
      término, se informará al usuario, se le expresará los motivos de la demora
      y se le señalará la fecha en que se atenderá su consulta, la cual no podrá
      superar los cinco (5) días hábiles siguientes al vencimiento del primer
      término.
    </p>
    <p>
      d. Revocación de autorización, retiro o supresión de la Base de Datos y
      reclamos Sobre Datos Personales. Cuando el titular de los datos o sus
      causahabientes consideren que la información contenida en las bases de
      datos debe ser objeto de corrección, actualización o supresión, o cuando
      adviertan el presunto incumplimiento de cualquiera de los deberes
      contenidos en la Ley 1581 de 2012, podrán presentar un reclamo ante <strong>Asegúrate Limitada</strong>., el cual
      será tramitado bajo las
      siguientes reglas:
    </p>
    <p>
      e.
    </p>
    <p>
      0. El reclamo se formulará mediante solicitud dirigida a <strong>Asegúrate Limitada</strong>. con la
      identificación de los
      Titulares, la descripción de los hechos que dan lugar al reclamo, la
      dirección, y se anexarán los documentos que se quieran hacer valer. Si el
      reclamo resulta incompleto, <strong>Asegúrate Limitada</strong>. podrá
      requerir al interesado dentro de los cinco (5) días siguientes a la
      recepción del reclamo para que subsane las fallas. Transcurridos dos (2)
      meses desde la fecha del requerimiento, sin que el solicitante presente la
      información requerida, se entenderá que ha desistido del reclamo. En caso
      de que <strong>Asegúrate Limitada</strong>. no sea competente para resolver
      el reclamo, dará traslado a quien corresponda en un término máximo de dos
      (2) días hábiles e informará de la situación al Titular, con lo cual
      quedará relevada de cualquier reclamación o responsabilidad por el uso,
      rectificación o supresión de los datos.
    </p>
    <p>
      1. Una vez recibido el reclamo completo, se incluirá en la base de datos
      una leyenda que diga "reclamo en trámite" y el motivo del mismo, en un
      término no mayor a dos (2) días hábiles. Dicha leyenda deberá mantenerse
      hasta que el reclamo sea decidido.
    </p>
    <p>
      El término máximo para atender el reclamo será de quince (15) días hábiles
      contados a partir del día siguiente a la fecha de su recibo. Cuando no
      fuere posible atender el reclamo dentro de dicho término, se informará al
      Titular los motivos de la demora y la fecha en que se atenderá su reclamo,
      la cual en ningún caso podrá superar los ocho (8) días hábiles siguientes
      al vencimiento del primer término.
    </p>
    <p>
      2. CONTACTO. Cualquier duda o información adicional será recibida y
      tramitada mediante su envío a las direcciones de contacto establecidas en
      la presente Política de Privacidad.
    </p>
    <p>
      3. Los datos personales incorporados en la Base de Datos estarán vigentes
      durante el plazo necesario para cumplir sus finalidades.
    </p>
    <p>
      4. CAMBIOS EN LA POLÍTICA DE PRIVACIDAD. Cualquier cambio sustancial en las
      políticas de Tratamiento, será comunicado oportunamente a los Titulares
      mediante la publicación en nuestros portales web.
    </p>
    <p>
      5. LEGISLACIÓN VIGENTE. La legislación nacional vigente en materia de
      protección de datos personales está contenida en la Ley 1581 de 2012, el
      Decreto 1377 de 2013 y la Ley 1266 de 2008 y las normas que lo modifiquen o
      complementen.
    </p>
  </mat-dialog-content>
</div>

<mat-dialog-actions align="end" >
  <button class="btn btn-primary font-weight-bold px-8 my-3" mat-button mat-dialog-close style="margin-right: 30px;"> Aceptar </button>
</mat-dialog-actions>
